/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceStepItem } from './SurfaceStepItem';
import {
    SurfaceStepItemFromJSON,
    SurfaceStepItemFromJSONTyped,
    SurfaceStepItemToJSON,
    SurfaceStepItemToJSONTyped,
} from './SurfaceStepItem';

/**
 * 
 * @export
 * @interface SurfaceStepsConfig
 */
export interface SurfaceStepsConfig {
    /**
     * 
     * @type {Array<SurfaceStepItem>}
     * @memberof SurfaceStepsConfig
     */
    steps?: Array<SurfaceStepItem>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepsConfig
     */
    layout?: SurfaceStepsConfigLayoutEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepsConfig
     */
    connectorStyle?: SurfaceStepsConfigConnectorStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStepsConfig
     */
    accentColor?: string;
}


/**
 * @export
 */
export const SurfaceStepsConfigLayoutEnum = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    alternating: 'alternating'
} as const;
export type SurfaceStepsConfigLayoutEnum = typeof SurfaceStepsConfigLayoutEnum[keyof typeof SurfaceStepsConfigLayoutEnum];

/**
 * @export
 */
export const SurfaceStepsConfigConnectorStyleEnum = {
    line: 'line',
    arrow: 'arrow',
    dots: 'dots',
    none: 'none'
} as const;
export type SurfaceStepsConfigConnectorStyleEnum = typeof SurfaceStepsConfigConnectorStyleEnum[keyof typeof SurfaceStepsConfigConnectorStyleEnum];


/**
 * Check if a given object implements the SurfaceStepsConfig interface.
 */
export function instanceOfSurfaceStepsConfig(value: object): value is SurfaceStepsConfig {
    return true;
}

export function SurfaceStepsConfigFromJSON(json: any): SurfaceStepsConfig {
    return SurfaceStepsConfigFromJSONTyped(json, false);
}

export function SurfaceStepsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStepsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'steps': json['steps'] == null ? undefined : ((json['steps'] as Array<any>).map(SurfaceStepItemFromJSON)),
        'layout': json['layout'] == null ? undefined : json['layout'],
        'connectorStyle': json['connectorStyle'] == null ? undefined : json['connectorStyle'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
    };
}

export function SurfaceStepsConfigToJSON(json: any): SurfaceStepsConfig {
    return SurfaceStepsConfigToJSONTyped(json, false);
}

export function SurfaceStepsConfigToJSONTyped(value?: SurfaceStepsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'steps': value['steps'] == null ? undefined : ((value['steps'] as Array<any>).map(SurfaceStepItemToJSON)),
        'layout': value['layout'],
        'connectorStyle': value['connectorStyle'],
        'accentColor': value['accentColor'],
    };
}

